import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useFieldArray, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Form from 'components/form/Form';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import BoxRow from './BoxRow';

const BoxModal = NiceModal.create(({ orderID, fetchDeliveryFee, formMethods, fieldName, setInputValue, required }) => {
	const { t } = useTranslation();
	const defaultBoxState = useSelector((state) => state.user.defaultBox);
	const defaultBox = defaultBoxState
		? {
				ID: defaultBoxState.id,
				width: defaultBoxState.width,
				height: defaultBoxState.height,
				length: defaultBoxState.length,
				name: defaultBoxState.boxName,
				weight: 1
			}
		: { width: 10, height: 10, length: 10, weight: 1 };

	const modal = useModal();

	const { control, getValues } = formMethods;
	const { fields, append, remove } = useFieldArray({
		control,
		name: `${fieldName}.boxes`
	});

	const watchedFields = useWatch({
		control,
		name: `${fieldName}.boxes`
	});

	const handleRemove = (index) => {
		remove(index);
		setInputValue((prev) => prev - 1);
	};

	const handleAdd = () => {
		append(defaultBox);
		setInputValue((prev) => prev + 1);
	};

	const handleCloseModal = async () => {
		if (fetchDeliveryFee) {
			const item = getValues(fieldName);
			const itemDcSettingsID = item?.dcSettingsID;

			if (itemDcSettingsID) {
				await fetchDeliveryFee(
					{
						dcSettingsID: itemDcSettingsID,
						orderID: item.orderID,
						boxes: watchedFields
					},
					fieldName
				);
			}
		}
		modal.remove();
	};

	return (
		<Modal maxWidth="x-large" fullwidth className="modal-withOtoRatesBulkBoxes">
			<ModalTitle>
				<Typography variant="p1">{`${orderID} - ${t('boxes')}`}</Typography>
			</ModalTitle>

			<ModalContent>
				<Form borderless formMethods={formMethods}>
					{fields.map((box, index) => (
						<BoxRow
							key={`${box.id}${index}`}
							remove={handleRemove}
							index={index}
							fieldName={`${fieldName}.boxes`}
							required={required}
							disabledDeleteButton={fields.length === 1}
						/>
					))}
				</Form>
			</ModalContent>

			<ModalActions>
				<Button label="addBox" icon={faPlus} variant="blackOutline" onClick={handleAdd} />
				<Button label="ok" onClick={handleCloseModal} />
			</ModalActions>
		</Modal>
	);
});

export default BoxModal;
